import { Theme } from '@mui/material';

export const styles = {
  storyItem: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '40px 0',
    [theme.breakpoints.down('lg')]: {
      padding: '40px 0',
    },
  }),
  messageItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  logo: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    overflow: 'hidden',
    '& img': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
  button: (theme: Theme) => ({
    '&.Mui-disabled': {
      border: 'none',
      '& svg': {
        '& path': {
          fill: theme.palette.text.disabled,
        },
      },
    },
  }),
};
